/** Maps an AHP `MessageAttachment` to `ReferenceChip` props (label + icon + state tint), delegating to the shared `attachment-icon` mapping. */

import type {Icon} from '@primer/octicons-react'
import type {MessageAttachment} from '@microsoft/agent-host-protocol'
import {
  attachmentToIcon,
  attachmentToIconColor,
  type AttachmentIconColor,
} from '@github-ui/copilot-shared-ui/components/attachment-icon'

export interface AttachmentChipProps {
  label: string
  icon: Icon
  color?: AttachmentIconColor
}

/** `label` is advisory in the AHP contract and may be empty at runtime, so fall back to a generic label to keep the chip's accessible name non-empty. */
export function attachmentToChipProps(attachment: MessageAttachment): AttachmentChipProps {
  return {
    label: attachment.label || 'attachment',
    icon: attachmentToIcon(attachment),
    color: attachmentToIconColor(attachment),
  }
}
